import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgFeedbackSomethingWrong(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m20.5 44.207 40 18.017v48.043l-40-18.017V44.207Z" fill="#007A5F" />
      <path
        d="m39.532 63.94-9.57 19.517 20.43 9.223-2.092-5.537-13.391-6.045 6.273-12.793-1.65-4.365Z"
        fill="#0F172A"
      />
      <path d="m29.962 83.457 20.43 9.223-2.092-5.537-13.391-6.045-4.947 2.36Z" fill="#223A52" />
      <path d="m41.182 68.304-6.273 12.793L48.3 87.143l-7.12-18.84Z" fill="#0F172A" />
      <path d="m100.5 44.207-40 18.017v48.043l40-18.017V44.207Z" fill="#599F40" />
      <path
        d="m89.747 84.159-18.494 8.306v-4.53l14.623-6.675V63.748l3.871-1.739v22.15Z"
        fill="#00664F"
      />
      <path d="m85.876 81.26-14.623 6.676v-17.62l14.623-6.568V81.26Z" fill="#0F172A" />
      <path d="m60.5 62.224 40-18.016-40-18.016-40 18.016 40 18.016Z" fill="#78B441" />
      <path
        d="m60.392 44.076-1.308-.589a15.055 15.055 0 0 0-11.432-.382l2.969 1.535-.282 3.965-2.71 1.22a14.984 14.984 0 0 0 11.405-.37l1.358-.611 1.309.589c3.622 1.631 7.979 1.9 11.678.523l-2.678-1.283v-4.358l2.432-1.21a15.055 15.055 0 0 0-11.432.382l-1.309.59Z"
        fill="#0F172A"
      />
      <path
        d="m60.618 44.201-1.308-.589a15.055 15.055 0 0 0-11.432-.382l-.906-.408c-1.517-.683-1.515-2.832.003-3.512a15.054 15.054 0 0 1 12.335.012l1.308.59 1.309-.59a15.055 15.055 0 0 1 12.335-.012c1.518.68 1.52 2.829.003 3.512l-.906.408a15.055 15.055 0 0 0-11.432.382l-1.309.59ZM50.565 48.73l.056-4.09-3.689 1.436c-1.506.678-1.508 2.81-.003 3.492.305.138.614.266.926.382l2.71-1.22ZM70.672 44.44v4.29l2.687 1.21c.304-.113.605-.236.903-.37 1.518-.68 1.52-2.828.003-3.512l-3.593-1.618Z"
        fill="#007A5F"
      />
      <path
        d="M46.278 27.379a.8.8 0 1 1 0 1.6H41.78a.8.8 0 1 1 0-1.6h4.497Zm-4.229-11.546a.8.8 0 0 1 1.105-.24l6.37 4.093a.8.8 0 0 1-.866 1.346l-6.369-4.094a.8.8 0 0 1-.24-1.105Zm12.953-4.975a.8.8 0 0 1 .975.574l.853 3.31a.8.8 0 0 1-1.549.4l-.854-3.31a.8.8 0 0 1 .575-.974Z"
        fill="#0F172A"
      />
      <path
        d="M66.626 32.785c4.157 7.18 5.108 14.394 2.125 16.112-2.982 1.717-8.77-2.712-12.927-9.892-4.157-7.181-5.11-14.395-2.126-16.112 2.983-1.718 8.77 2.711 12.928 9.892Z"
        fill="#00664F"
      />
      <path
        d="M84.582 39.782c2.983-1.718 2.031-8.931-2.126-16.112-4.157-7.18-9.945-11.61-12.928-9.892l-15.83 9.115c2.983-1.717 8.77 2.712 12.928 9.892 4.157 7.181 5.108 14.395 2.125 16.112l15.831-9.115Z"
        fill="#599F40"
      />
      <path
        d="M82.456 23.67c-4.157-7.18-9.945-11.61-12.928-9.892l-15.83 9.115c2.983-1.717 8.77 2.712 12.928 9.892l19.636 1.567c-.282-3.01-1.588-6.85-3.806-10.682Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgFeedbackSomethingWrong)
